import { apiClient } from "../api"
import { stringifyParams } from "../utils/api"
import {
  AreaMonitoringParam,
  DTO_AreaMonitoringReport,
  DTO_EmissionsReport,
  DTO_FuelPurchaseReport,
  DTO_IdleStopsReport,
  DTO_MaintenanceReport,
  DTO_SpeedViolationReport,
  DTO_TemperatureQualityMonitoring,
  DTO_TemperatureQualityReport,
  DTO_TemperatureReport,
  DTO_WeeklyWorkingReport,
  EmissionsReportParam,
  FuelPurchaseReportParam,
  IdelStopReportParam,
  MaintenanceParam,
  SpeedViolationParam,
  TemperatureQualityMonitoringParam,
  TemperatureQualityParam,
  TemperatureReportParam,
  VehicleDistanceReportParam,
  WeeklyWorkingReportParam,
} from "./types/reports"

const API_REPORTS = '/reports/'
enum Report {
  VEHICLE = `${API_REPORTS}vehiclereport/`,
  TACHOGRAPH = `${API_REPORTS}tachograph/`,
  TAG = `${API_REPORTS}tags/`,
  DAY_OVERVIEW = `${API_REPORTS}day_overview/`,
  FUEL_PURCHASE = `${API_REPORTS}fuelpurchase/`,
  EMISSIONS = `${API_REPORTS}emissions/`,
  TEMPERATURE = `${API_REPORTS}temperature/`,
  AREA_MONITORING = `${API_REPORTS}areamonitoring/`,
  SPEEDING = `${API_REPORTS}speeding/`,
  TEMP_QUALITY_MON = `${API_REPORTS}temperature_quality_monitoring/`,
  TEMP_QUALITY = `${API_REPORTS}temperature_quality/`,
  MAINTENANCE = `${API_REPORTS}maintenance/`,
  IDLE_STOPS = `${API_REPORTS}idlestops/`,
  WEEKLY_HOURS = `${API_REPORTS}weekly_hours/`,
  VEHICLE_DISTANCE = `${API_REPORTS}vehicle_distance/`
}

export const getVehicleReport = (params: any) => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.VEHICLE}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportVehicleReport = (params: any, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.VEHICLE}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getTachographReport = (params: any) => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.TACHOGRAPH}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportTachographReport = (params: any, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.TACHOGRAPH}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getTagReport = (params: any) => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.TAG}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportTagReport = (params: any, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.TAG}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getDayOverviewReport = (params: any) => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.DAY_OVERVIEW}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportDayOverviewReport = (params: any, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.DAY_OVERVIEW}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getFuelPurchasesReport = (params: FuelPurchaseReportParam): Promise<DTO_FuelPurchaseReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.FUEL_PURCHASE}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportFuelPurchasesReport = (params: FuelPurchaseReportParam, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.FUEL_PURCHASE}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getEmissionsReport = (params: EmissionsReportParam): Promise<DTO_EmissionsReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.EMISSIONS}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportEmissionsReport = (params: EmissionsReportParam, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.EMISSIONS}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getTemperatureReport = (params: TemperatureReportParam): Promise<DTO_TemperatureReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.TEMPERATURE}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportTemperatureReport = (params: TemperatureReportParam, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.TEMPERATURE}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getAreaMonitoringReport = (params: AreaMonitoringParam): Promise<DTO_AreaMonitoringReport[]> => {
  const ac = apiClient()
  const filterOutVisited = params.visited
  delete params.visited
  const queryStr = stringifyParams(params)
  const addUrlString = filterOutVisited ? 'unvisited_locations/' : ''
  const promise = ac.get(`${Report.AREA_MONITORING}${addUrlString}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportAreaMonitoringReport = (params: AreaMonitoringParam, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const filterOutVisited = params.visited
  delete params.visited
  const queryStr = stringifyParams({ ...params, format: type })
  const addUrlString = filterOutVisited ? 'unvisited_locations/' : ''
  const promise = ac.get(`${Report.AREA_MONITORING}${addUrlString}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getSpeedViolationReport = (params: SpeedViolationParam): Promise<DTO_SpeedViolationReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.SPEEDING}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportSpeedViolationReport = (params: SpeedViolationParam, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.SPEEDING}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getTemperatureQualityMonitoringReport = (params: TemperatureQualityMonitoringParam): Promise<DTO_TemperatureQualityMonitoring[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.TEMP_QUALITY_MON}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportTemperatureQualityMonitoringReport = (params: TemperatureQualityMonitoringParam, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.TEMP_QUALITY_MON}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getMaintenanceReport = (params: MaintenanceParam): Promise<DTO_MaintenanceReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.MAINTENANCE}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportMaintenanceReport = (params: MaintenanceParam, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.MAINTENANCE}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getTemperatureQualityReport = (params: TemperatureQualityParam): Promise<DTO_TemperatureQualityReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.TEMP_QUALITY}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportTemperatureQualityReport = (params: TemperatureQualityParam, type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.TEMP_QUALITY}export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getIdleStopsReport = (params: IdelStopReportParam, period: 'year' | 'month' | 'week' = 'year'): Promise<DTO_IdleStopsReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.IDLE_STOPS}${period}/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportIdleStopsReport = (params: IdelStopReportParam, period: 'year' | 'month' | 'week' = 'year', type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.IDLE_STOPS}${period}/export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getWeeklyWorkingHoursReport = (params: WeeklyWorkingReportParam, period: 'year' | 'month' | 'week' = 'year'): Promise<DTO_WeeklyWorkingReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.WEEKLY_HOURS}${period}/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportWeeklyWorkingHoursReport = (params: WeeklyWorkingReportParam, period: 'year' | 'month' | 'week' = 'year', type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.WEEKLY_HOURS}${period}/export/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}

export const getVehicleDistanceReport = (params: VehicleDistanceReportParam, period: 'year' | 'month' | 'week' = 'year'): Promise<DTO_WeeklyWorkingReport[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Report.VEHICLE_DISTANCE}${period}/${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const exportVehicleDistanceReport = (params: VehicleDistanceReportParam, period: 'year' | 'month' | 'week' = 'year', type: 'pdf' | 'excel'): Promise<Blob> => {
  const ac = apiClient()
  const queryStr = stringifyParams({ ...params, format: type })
  const promise = ac.get(`${Report.VEHICLE_DISTANCE}${period}/${queryStr?.length ? `?${queryStr}` : ''}`, {
    responseType: 'blob'
  })
    .then(res => res.data)
  return promise
}
